// if (!global._babelPolyfill) {
//     require('babel-polyfill');
// }

import '@razz-interactive/vue-components/dist/razz.css';
import '@razz-interactive/zeki-embed/dist/zekiEmbed.css';
import {installZekiEmbed} from '@razz-interactive/zeki-embed';

const url = window.zeki && zeki.zeki_property_url;
const path = window.zeki && zeki.zeki_path;

if (url) {
    installZekiEmbed({
        path,
        url,
    });
}
